import React, { useState } from 'react'
import {
  LocalizationProvider,
  PickersDay,
  StaticDatePicker
} from '@mui/x-date-pickers'
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns'
import TextField from '@mui/material/TextField'
import isSameDay from 'date-fns/isSameDay'
import { getLocaleByLang } from '../form/components/inputs/datePicker'
import { useSelector } from 'react-redux'
import { parseISO } from 'date-fns'

const DynamicCalendar = ({
  disabledDates,
  onChange,
  disabled,
  disablePast,
  selectedDates
}) => {
  const [selectedDate, setSelectedDate] = useState(null)

  // Format disabled dates to Date objects for comparison
  const disabledDateObjects = disabledDates.map((date) => new Date(date))

  const handleDateChange = (date) => {
    setSelectedDate(date)
    if (onChange) {
      onChange(date) // Trigger the custom onChange function passed as a prop
    }
  }

  // Function to check if a date should be disabled
  const shouldDisableDate = (date) => {
    return disabledDateObjects.some((disabledDate) =>
      isSameDay(date, disabledDate)
    )
  }

  const customDay = (props) => {
    const { day } = props
    const isSelected = selectedDates?.some((selectedDay) =>
      isSameDay(day, parseISO(selectedDay))
    )

    return <PickersDay {...props} day={day} selected={isSelected} />
  }

  const lang = useSelector((state) => state.language.lang)
  const locale = React.useMemo(() => getLocaleByLang(lang), [lang]) // Dynamically set locale

  return (
    <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={locale}>
      <StaticDatePicker
        displayStaticWrapperAs="desktop"
        openTo="day"
        value={selectedDate}
        onChange={handleDateChange} // Call handleDateChange on date selection
        shouldDisableDate={shouldDisableDate}
        disabled={disabled}
        disablePast={disablePast}
        slots={{ day: customDay }}
        renderInput={(params) => <TextField {...params} />}
      />
    </LocalizationProvider>
  )
}

export default DynamicCalendar
